var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandCoins(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HandCoins"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.2,
    d: "M5 19.5H2C1.80109 19.5 1.61032 19.421 1.46967 19.2803C1.32902 19.1397 1.25 18.9489 1.25 18.75V15C1.25 14.8011 1.32902 14.6103 1.46967 14.4697C1.61032 14.329 1.80109 14.25 2 14.25H5V19.5Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.2,
    d: "M19.625 5.25009C19.2358 5.25034 18.8515 5.33712 18.5 5.50416C18.4745 4.94116 18.2684 4.40132 17.9123 3.96449C17.5563 3.52766 17.069 3.21703 16.5227 3.07854C15.9764 2.94005 15.4001 2.98105 14.8789 3.19549C14.3577 3.40993 13.9194 3.78642 13.6287 4.26926C13.3381 4.75211 13.2105 5.31568 13.265 5.87662C13.3194 6.43756 13.5529 6.96609 13.931 7.38403C14.3091 7.80198 14.8116 8.08715 15.3643 8.19736C15.917 8.30758 16.4905 8.23699 17 7.99603C17.0237 8.50939 17.1975 9.00451 17.5 9.41999C17.8024 9.83547 18.2202 10.153 18.7014 10.3333C19.1827 10.5136 19.7063 10.5486 20.2072 10.4341C20.7082 10.3195 21.1646 10.0605 21.5197 9.68899C21.8748 9.31752 22.1131 8.84998 22.2049 8.34435C22.2968 7.83872 22.2382 7.31725 22.0365 6.8446C21.8347 6.37194 21.4987 5.96891 21.07 5.68546C20.6413 5.40202 20.1389 5.25064 19.625 5.25009Z",
    fill: "#FFB600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.625 10.5C21.0747 10.5 22.25 9.32475 22.25 7.875C22.25 6.42525 21.0747 5.25 19.625 5.25C18.1753 5.25 17 6.42525 17 7.875C17 9.32475 18.1753 10.5 19.625 10.5Z",
    fill: "#FFB600",
    stroke: "#343330",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5 19.5H2C1.80109 19.5 1.61032 19.421 1.46967 19.2803C1.32902 19.1397 1.25 18.9489 1.25 18.75V15C1.25 14.8011 1.32902 14.6103 1.46967 14.4697C1.61032 14.329 1.80109 14.25 2 14.25H5",
    stroke: "#343330",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11 15H14L20.2812 13.5553C20.5122 13.492 20.7546 13.4829 20.9897 13.5285C21.2247 13.5741 21.4461 13.6734 21.6365 13.8185C21.827 13.9636 21.9814 14.1507 22.0878 14.3652C22.1942 14.5797 22.2497 14.8159 22.25 15.0553C22.2501 15.3444 22.1697 15.6279 22.0176 15.8738C21.8656 16.1197 21.648 16.3184 21.3894 16.4475L17.75 18L11.75 19.5H5V14.25L7.34375 11.9063C7.55324 11.6975 7.80182 11.5321 8.0753 11.4195C8.34877 11.3069 8.64175 11.2493 8.9375 11.25H13.625C14.1223 11.25 14.5992 11.4476 14.9508 11.7992C15.3025 12.1508 15.5 12.6277 15.5 13.125C15.5 13.6223 15.3025 14.0992 14.9508 14.4508C14.5992 14.8025 14.1223 15 13.625 15H11Z",
    stroke: "#343330",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17 7.99603C16.4905 8.23699 15.917 8.30758 15.3643 8.19736C14.8116 8.08715 14.3091 7.80198 13.931 7.38404C13.5529 6.96609 13.3194 6.43756 13.265 5.87662C13.2105 5.31568 13.3381 4.75211 13.6287 4.26926C13.9194 3.78642 14.3577 3.40993 14.8789 3.19549C15.4001 2.98105 15.9764 2.94005 16.5227 3.07854C17.069 3.21703 17.5563 3.52766 17.9123 3.96449C18.2684 4.40132 18.4745 4.94116 18.5 5.50416",
    stroke: "#343330",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandCoins);
export default __webpack_public_path__ + "static/media/HandCoins.8b181f4639d1aacd7d6862b2d6abb3dc.svg";
export { ForwardRef as ReactComponent };